import queryString from 'query-string';

const loader = () => {
	const { hash } = document.location;
	const { brand_id, client_id } = queryString.parse(hash);
	let path = `app.${brand_id.toLowerCase()}`;
	const clientId = client_id.toUpperCase();
	if (clientId === 'MEO' || clientId === 'IB_ADVISOR') {
		path = 'app.cb.internal';
	}
	const link = document.createElement('link');
	link.rel = 'stylesheet';
	link.href = `${window.location.origin}/${path}.${process.env.GIT_HASH}.css`;
	document.head.appendChild(link);
};

loader();

export default loader;
